import React, { useEffect } from 'react';
import { Formik, Field } from 'formik';
import Button from '../../../general/button/button.component';
import './experiencedetails.student.styles.scss';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Padding from './../../../general/padding/Padding';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc } from "firebase/firestore"; 
import { globalUSN } from "../../general/sign-up/sign-up.component"
import db from '../../../../firebase.config';
import ProgressIndicator from '../../general/progress-indicator/progress-indicator.component';
import { Backdrop, CircularProgress } from '@mui/material';


const ExperienceDetails = () => {

  let navigate = useNavigate();
  useEffect(() => {
    console.log(globalUSN);
    if(!globalUSN)
      navigate('../../../sessionexpired')
  })

  return (
  <div>
    <Formik
      initialValues={{ clubs: '', ecc: '', companies: '', certifications: '', projectsandinternships: ''}}
      validate={values => {
        const errors = {};
        if (!values.clubs) {
          errors.clubs = 'Required';
        }
        if (!values.ecc) {
          errors.ecc = 'Required';
        }
        if (!values.certifications) {
          errors.certifications = 'Required';
        }
        if (!values.projectsandinternships) {
          errors.projectsandinternships = 'Required';
        }
        return errors;
      }}
      onSubmit={(values, { setSubmitting }) => {

//firebase
values.clubs = values.clubs.split('\n');
values.ecc = values.ecc.split('\n');
values.certifications = values.certifications.split('\n');
values.projectsandinternships = values.projectsandinternships.split('\n');
if(values.companies)
{
values.companies = values.companies.split('\n');
values.companies = values.companies.map((company, index) => ({ company : company.split(',')[0], typeofjob : company.split(',')[1], salary : company.split(',')[2] }))
}
const data = JSON.parse(JSON.stringify(values, null, 2));
  console.log(data);
  try {
  const studentRef = doc(db, 'studentData', globalUSN);
  console.log(studentRef);
  setDoc(studentRef, data , { merge: true });
  }
  catch (err)
  {
    console.log(err);
  }
setSubmitting(true);
setTimeout(() => {navigate(`../../../signupsignin`);},3000)

}}
    >
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting
      }) => (
        
        <form onSubmit={handleSubmit}> 
        <ProgressIndicator />
        <span className="personal-details" style={{marginBottom:'3%'}}>
          <Typography variant="h4" sx={{fontFamily:'Montserrat'}}>Experience details 	&#40;Type each in a new line&#41;</Typography>
          <Field id="textarea1" as="textarea" name="clubs" placeholder="Clubs Involved"/>
          <span style={{fontFamily : 'Montserrat'}}>{touched.clubs && errors.clubs}</span>
          <Field id="textarea1" as="textarea" name="ecc" placeholder="Extra Curricular Activites"/>
          <span style={{fontFamily : 'Montserrat'}}>{touched.clubs && errors.clubs}</span>
          <Field id="textarea1" as="textarea" name="companies" placeholder="Companies placed in"/>
          <span style={{fontFamily : 'Montserrat'}}>{touched.clubs && errors.clubs}</span>
        </span>

        <span className="personal-details" style={{marginBottom:'1px'}}>
          <Padding/>
          <Padding/>
          <Field id="textarea2" as="textarea" name="certifications" placeholder="Certifications"/>
          <span style={{fontFamily : 'Montserrat'}}>{touched.clubs && errors.clubs}</span>
          <Field id="textarea2" as="textarea" name="projectsandinternships" placeholder="Projects and Internships"/>
          <span style={{fontFamily : 'Montserrat'}}>{touched.clubs && errors.clubs}</span>
          </span>
          <span className="personal-details">
          <Button type="submit" disabled={isSubmitting}>
            Next
          </Button>
          <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isSubmitting}
          >
          <CircularProgress color="inherit" />
          </Backdrop>
        </span>
        </form>
      )}
    </Formik>
  </div>
  );
}

export default ExperienceDetails;

